import { render, staticRenderFns } from "./BsnPlnMemberDetail.vue?vue&type=template&id=424eb520&"
import script from "./BsnPlnMemberDetail.vue?vue&type=script&lang=js&"
export * from "./BsnPlnMemberDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports